import { useEffect } from 'react';
import { Box, Divider, Paper, Stack, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InvoiceModel } from '../../../api/gql';
import { FormBooleanIndicator } from '../../../components/form/FormBooleanIndicator';
import { FormInput } from '../../../components/form/FormInput';

type ModelFormType = Pick<InvoiceModel, 'name' | 'fields'>;

type Props = {
  defaultValues: ModelFormType;
  readonly: boolean;
};
const TRANS_NS = 'universal-reminding';

export const ModelForm = ({ defaultValues, readonly }: Props) => {
  const { t } = useTranslation(TRANS_NS, { keyPrefix: 'scenarios' });

  const { control, reset } = useForm<ModelFormType>({
    defaultValues: defaultValues,
  });

  useEffect(() => {
    if (readonly) {
      reset(defaultValues);
    }
  }, [readonly, defaultValues, reset]);

  return (
    <form onSubmit={() => null}>
      <Stack direction={'column'} gap={2}>
        <FormInput control={control} name={'name'} label={t('form.name')} readonly={readonly} />
        <Stack>
          <Typography variant={'caption'} color={'text.secondary'}>
            {t('model.variables')}
          </Typography>
          <Divider />
          <Box mt={2} display={'flex'} flexWrap={'wrap'} gap={4}>
            {defaultValues.fields?.map((field, i) => (
              <Paper key={i} sx={{ p: 1, backgroundColor: 'surface.light' }}>
                <Stack direction={'row'} gap={1} alignItems={'center'}>
                  <Box>
                    <FormInput control={control} name={`fields.${i}.name`} label={t('form.name')} readonly={readonly} />
                  </Box>
                  <Box>
                    <FormBooleanIndicator
                      control={control}
                      name={`fields.${i}.required`}
                      label={t('model.required')}
                      readonly={readonly}
                    />
                  </Box>
                </Stack>
              </Paper>
            ))}
          </Box>
        </Stack>
      </Stack>
    </form>
  );
};
